// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__f385M","unreadBadge":"styles_unreadBadge__-ryhF","modalContent":"styles_modalContent__23ySq","modal":"styles_modal__YFO6-"};